import { PhoneNumberUtil } from "google-libphonenumber";
const phoneUtil = PhoneNumberUtil.getInstance();
export const isPhoneValid = (phone) => {
    try {
        const code = phoneUtil.getRegionCodeForNumber(phoneUtil.parseAndKeepRawInput(phone));
        // ZA specific validation: ensure at least 9 digits for national number,
        // before entering google-libphonenumber validation.
        if (code === "ZA") {
            const phoneNumber = phoneUtil.parse(phone).getNationalNumber();
            if (phoneNumber === undefined || phoneNumber.toString().length < 9) {
                return false;
            }
        }
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
    }
    catch (error) {
        return false;
    }
};
